module.exports = __webpack_public_path__ + "img/15000.529cabae.jpg";